import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { lang } from '../../../utils/langs';
import './style.css';
import { getPayMethods } from '../../../usecases/payments-usecase';
import { dispatchCustomEvent } from '../../../utils/dispatch';
import { BsTrash, BsCash, BsCreditCard, BsBank, BsPhone } from 'react-icons/bs';

const PaymentMethodSelector = ({ onSelectMethod, selectedMethods, selectedFormPay, selectedFormPayValue, onRemoveMethod, onAmountChange, enableFormPay = false, defaultAmount = 0 }) => {

  const [paymethods, SetPayMethods] = useState([]);
  const [local, setLocal] = useState([]);

  useEffect(() => {
    handleFormOpen();
  }, []);

  useEffect(() => {
    setLocal(selectedMethods || []);
  }, [selectedMethods]);

  function handleFormOpen() {
    getPayMethods("", "").then((res) => {
      SetPayMethods(res);
    }).catch((error) => {
      dispatchCustomEvent("popup", {
        message: error,
        type: "error"
      });
    });
  }

  const handleSelectChange = (e) => {
    const methodId = parseInt(e.target.value);
    if (isNaN(methodId)) return;

    const method = paymethods.find(m => m.id === methodId);
    if (!method) return;

    if (!local.some(m => m.id === methodId)) {
      // Apply remaining amount only if it's the first matching method
      const initialValue = local.length === 0 ? defaultAmount : 0;
      const next = [...local, { ...method, value: initialValue }];
      setLocal(next);
      if (onSelectMethod) onSelectMethod(next);
    }

    // Reset select to default option
    e.target.value = "---";
  };

  const handleAmountChange = (methodId, e) => {
    const val = parseFloat(e.target.value) || 0;
    const next = local.map(method =>
      method.id === methodId ? { ...method, value: val } : method
    );
    setLocal(next);
    if (onAmountChange) onAmountChange(next);
  };

  const handleRemove = (selectedMethodID) => {
    const next = local.filter(method => method.id !== parseInt(selectedMethodID));
    setLocal(next);
    if (onRemoveMethod) onRemoveMethod(next);
  };

  const getMethodIcon = (methodName = "") => {
    const lowerName = methodName.toLowerCase();
    if (lowerName.includes('efectivo')) return <BsCash />;
    if (lowerName.includes('tarjeta') || lowerName.includes('debito') || lowerName.includes('credito')) return <BsCreditCard />;
    if (lowerName.includes('transferencia') || lowerName.includes('banco')) return <BsBank />;
    if (lowerName.includes('nequi') || lowerName.includes('daviplata') || lowerName.includes('qr')) return <BsPhone />;
    return <BsCash />;
  };

  return (
    <div className="payment-method-selector">
      {enableFormPay && (
        <div className="form-group-section mb-3">
          <Form.Label className='lable'>Forma de pago:</Form.Label>
          <Form.Select
            id="select-pay-form"
            value={selectedFormPayValue ?? "---"}
            onChange={(e) => selectedFormPay(e.target.value)}
            className="form-select-premium"
          >
            <option value="---">Selecciona una forma de pago</option>
            <option value={1}>Contado</option>
            <option value={2}>Credito</option>
          </Form.Select>
        </div>
      )}

      <div className="form-group-section">
        <Form.Label className='lable'>Añadir método de pago:</Form.Label>
        <Form.Select
          id="select-pay-methods"
          onChange={handleSelectChange}
          defaultValue="---"
          className="form-select-premium"
        >
          <option value="---">Elige un método (Efectivo, Tarjeta, etc)</option>
          {
            paymethods?.filter(method => !local.some(sm => sm.id === method.id)).map((method) => (
              <option key={method.id} value={method.id}>
                {lang("es", method?.method)}
              </option>
            ))
          }
        </Form.Select>
      </div>

      {(local ?? []).length > 0 && (
        <div className="selected-payment-methods-display mt-3">
          {(local ?? []).map(selectedMethod => {
            return (
              <div key={selectedMethod.id} className="selected-method-item">
                <div className="method-info">
                  <span className="method-name">
                    {getMethodIcon(selectedMethod?.method)}
                    {lang("es", selectedMethod?.method)}
                  </span>
                </div>

                <div className="amount-input-group">
                  <Form.Control
                    type="number"
                    step="50"
                    placeholder="Monto"
                    value={selectedMethod.value}
                    onChange={(e) => handleAmountChange(selectedMethod.id, e)}
                    onFocus={(e) => e.target.select()}
                  />
                </div>

                <button
                  type="button"
                  className="remove-method-btn"
                  onClick={() => handleRemove(selectedMethod.id)}
                  title="Eliminar método"
                >
                  <BsTrash size={18} />
                </button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default PaymentMethodSelector;
